import { render, staticRenderFns } from "./DocumentTeaser.vue?vue&type=template&id=15ebaa3a&scoped=true&"
import script from "./DocumentTeaser.vue?vue&type=script&lang=js&"
export * from "./DocumentTeaser.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTeaser.vue?vue&type=style&index=0&id=15ebaa3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ebaa3a",
  null
  
)

export default component.exports